module.exports = __webpack_public_path__ + "static/media/Group.1a9211d0.svg";